import NewsMain from './NewsMain';

export default NewsMain;
